export default __webpack_public_path__ + "static/media/default.daf2d735aee1dc753d1c70305579efd2.png";